import ManageClients from '../../components/client/manage-clients/ManageClients';

const ManageClient = () => {
  return <ManageClients />;
};

export default ManageClient;
